const PropTypes = require('prop-types');
//@vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
//@helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { ACCOUNT_CANCEL_CHEQUEBOOK_ID } = require('constants/operationTypes');
//@components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

class AccountCancelChequebookStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const {immAccounts, accountId} = this.props;
        const newProduct = immAccounts.getIn(['byId', accountId, 'newProduct']);
        const newContractNumber = immAccounts.getIn(['byId', accountId, 'newContractNumber']);
        const originAccount = API_ENTERPRISE_NUMBER + API_CENTER + newProduct + newContractNumber
        const operative = formatText('operatives-undoCheckbook');

        const operationParams = {
            originAccount
        }
        return (
            <article className="account-cancel-chequebook-step">
                <header className="account-cancel-chequebook-step__header">
                    <h5 className="account-cancel-chequebook-step__title">
                        <FormattedText value="accountCancelChequebook-cancelChequebookConfirmation"/>
                    </h5>
                </header>
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={operative}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <section>
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    <SignaturePattern
                        operationType={ACCOUNT_CANCEL_CHEQUEBOOK_ID}
                        operationParams={operationParams}
                    />
                </section>
            </article>
        );
    }
}

AccountCancelChequebookStep2.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    accountId: PropTypes.string.isRequired
}

module.exports = AccountCancelChequebookStep2;